import React from "react";
import { css, cx } from "emotion";
import { defaultStyle } from "./style";

const Panel = ({ className, children, overflow = true }) => {
	return (
		<div
			className={cx(
				css`
					${defaultStyle(overflow)}
				`,
				className
			)}
		>
			{children}
		</div>
	);
};

export default Panel;
